<script>
  export default {
    name: 'NavBar',
    data() {
      return {
        menuBurgerOuvert: false,
      }
    },
    methods: {
      affichageMenuBurger() {
        this.menuBurgerOuvert = true
      },
      fermerMenu(event) {
        if (
          event.target === event.currentTarget ||
          event.target.closest('#croix-fermeture')
        ) {
          this.menuBurgerOuvert = false
        }
      },
    },
    computed: {
      estMenuBurgerOuvert() {
        return this.menuBurgerOuvert
      },
    },
  }
</script>

<template>
  <nav id="navbar">
    <ul id="navbar-large">
      <li>
        <router-link to="/">HOME</router-link>
      </li>
      <li>
        <router-link to="/pascal-chove">PASCAL CHÔVE</router-link>
      </li>
      <li>
        <router-link to="/peintures">PEINTURES</router-link>
      </li>
      <li>
        <router-link to="/sculptures">SCULPTURES</router-link>
      </li>
      <li>
        <router-link to="/videos">VIDÉOS</router-link>
      </li>
      <li>
        <router-link to="/dessins">DESSINS</router-link>
      </li>
      <li>
        <router-link to="/contact">CONTACT</router-link>
      </li>
    </ul>

    <div id="navbar-burger" @click="affichageMenuBurger">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        class="bi bi-list"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
        ></path>
      </svg>
    </div>

    <div v-if="estMenuBurgerOuvert" id="menu-burger" @click="fermerMenu">
      <ul id="menu-list">
        <li id="titre-liste">
          <p>MENU</p>
        </li>
        <li class="nav-link">
          <router-link to="/" @click="fermerMenu">HOME</router-link>
        </li>
        <li class="nav-link">
          <router-link to="/pascal-chove" @click="fermerMenu"
            >PASCAL CHÔVE</router-link
          >
        </li>
        <li class="nav-link">
          <router-link to="/peintures" @click="fermerMenu"
            >PEINTURES</router-link
          >
        </li>
        <li class="nav-link">
          <router-link to="/sculptures" @click="fermerMenu"
            >SCULPTURES</router-link
          >
        </li>
        <li class="nav-link">
          <router-link to="/videos" @click="fermerMenu">VIDÉOS</router-link>
        </li>
        <li class="nav-link">
          <router-link to="/dessins" @click="fermerMenu">DESSINS</router-link>
        </li>
        <li class="nav-link">
          <router-link to="/contact" @click="fermerMenu">CONTACT</router-link>
        </li>
        <li>
          <div id="croix-fermeture" @click="fermerMenu">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              fill="rgb(92, 92, 92)"
              class="bi bi-x-square"
              viewBox="0 0 16 16"
            >
              <path
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
              ></path>
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
              ></path>
            </svg>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<style scoped>
  #navbar {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 500;
    background-color: rgb(242, 242, 242);
    justify-content: center;
    align-items: center;
    margin-bottom: 3em;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    min-height: 40px;
  }

  ul {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  li {
    list-style: none;
  }

  a {
    display: inline-block;
    color: rgb(92, 92, 92);
    padding: 8px 3vw;
  }

  .router-link-exact-active {
    color: rgb(0, 0, 0);
  }

  #navbar-large {
    display: inline-flex;
  }

  #navbar-burger {
    display: none;
  }

  #menu-burger {
    position: fixed;
    top: 0;
    z-index: 200;
    background-color: rgba(0, 0, 0, 0.75);
    width: 100%;
    height: 100%;
    overscroll-behavior: contain;
  }

  #menu-list {
    margin-left: auto;
    width: 75%;
    height: 100vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
  }

  #menu-list li {
    padding: 8px 16px;
  }

  .nav-link {
    display: block;
    background-color: white;
    font-size: 24px;
    margin-right: 16px;
  }

  #titre-liste {
    display: flex;
    justify-content: flex-end;
    background-color: black;
    color: white;
    font-size: 24px;
    width: 100%;
  }

  #titre-liste p {
    margin-right: 16px;
    padding: 0 3vw;
  }

  #croix-fermeture {
    margin-right: 16px;
    padding: 0 3vw;
  }
  @media (max-width: 768px) {
    #navbar-burger {
      display: flex;
    }

    #navbar-large {
      display: none;
    }
  }
</style>
